import { PageSection } from './SectionAttributes';
import { SectionType } from './SectionType';

export const NebNextButtonVariant = {
  BUTTON: 'button',
} as const;

export type NebNextButtonVariant = (typeof NebNextButtonVariant)[keyof typeof NebNextButtonVariant];

export interface NebSectionNextButtonAttributes extends PageSection {
  content: {
    variant: NebNextButtonVariant;
    label: string;
  };
  sectionType: SectionType.NEB_NEXT_BUTTON;
}
